import React, { useEffect, useState } from 'react';
import { Phone, MessageCircle, ChevronUp } from 'lucide-react';

export default function SupportBar() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 400);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-end gap-3">
      <div className="backdrop-blur-sm border border-white/20 shadow-[0_20px_40px_rgba(0,0,0,0.25)] rounded-full overflow-hidden" style={{ backgroundColor: '#F1D291', color: '#2A4343' }}>
        <div className="flex items-center">
          <a
            href="https://wa.me/919004304730"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 px-4 py-2 text-xs uppercase tracking-[0.3em] hover:bg-black/10"
            style={{ color: '#2A4343' }}
          >
            <MessageCircle size={16} style={{ color: '#2A4343' }} /> WhatsApp
          </a>
          <a
            href="tel:+919004304730"
            className="flex items-center gap-2 px-4 py-2 text-xs uppercase tracking-[0.3em] border-l hover:bg-black/10"
            style={{ color: '#2A4343', borderLeftColor: '#2A4343' }}
          >
            <Phone size={16} style={{ color: '#2A4343' }} /> Call
          </a>
        </div>
      </div>
      {showTop && (
        <button
          onClick={scrollTop}
          aria-label="Back to top"
          className="w-10 h-10 rounded-full border flex items-center justify-center hover:bg-black/10"
          style={{ backgroundColor: '#F1D291', color: '#2A4343', borderColor: '#2A4343' }}
        >
          <ChevronUp size={16} style={{ color: '#2A4343' }} />
        </button>
      )}
    </div>
  );
}